import { API } from '../../common/constants/urls';
import { get } from '../../common/axiosClient';
import { ProjectVersion, ProjectVersionInfo } from './project.type';

export const getProjectVersions = async (projectId: string) => {
  return (await get(`${API.PROJECT_VERSION}${projectId}`)) as ProjectVersionInfo[];
};

export const getProjectVersion = async (projectId: string, versionId: string) => {
  return (await get(`${API.PROJECT_VERSION}${projectId}/${versionId}`)) as ProjectVersion;
};
